import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import gsap from 'gsap'

export class InteractiveMap {
  constructor() {
    this.mapWrappers = document.querySelectorAll('.js-interactive-map-wrapper')
    if (this.mapWrappers.length <= 0 ) { return false }

    this.mapWrappers.forEach(mapWrapper => {
      this.init(mapWrapper)
    })

  }

  init = (mapWrapper) => {
    this.mapWrapper = mapWrapper

    const scripts = [...this.mapWrapper.querySelectorAll('script')]

    for (const script of scripts) {
      const code = script.innerText;

      if (code.length !== 0) {
        Function(code)();
      }
    }

    this.setDefaults()
    this.createMap()
    this.drawOnMap()
    this.bindEvents()
  }

  setDefaults = () => {
    this.map = this.mapWrapper.querySelector('.js-interactive-map')

    this.polyline = JSON.parse(localStorage.getItem('polylineData'))
    this.centerMap = JSON.parse(localStorage.getItem('centerOfMap'))
    this.zoomLevel = JSON.parse(localStorage.getItem('zoomLevel'))
    this.geojson = JSON.parse(localStorage.getItem('geojson'))

    // this.polyline = polylineData
    // this.centerMap = centerOfMap
    // this.zoomLevel = zoomLevel
    // this.geojson = geojson

    this.sidePanel = this.mapWrapper.querySelector('.js-sidepanel')
    this.sidePanelTop = this.sidePanel.querySelector('.js-sidepanel-top')
    this.sidePanelBottom = this.sidePanel.querySelector('.js-sidepanel-bottom')
    this.sidePanelCloseButton = this.sidePanel.querySelector('.js-sidepanel-close')

    this.panelOpen = false
  }

  bindEvents = () => {
    this.sidePanelCloseButton.addEventListener('click', () => {
      this.panelOpen = false
      this.closePanel()

    })
  }

  createMap = () => {
    mapboxgl.accessToken = 'pk.eyJ1IjoibGFtYWxhbWFubCIsImEiOiJjbDhyZ3k0aTUzM2pqM3BvNTc5dnA1Zjh6In0.JZUMOyD2t45uG7ScnIqQWA';

    this.mapBox = new mapboxgl.Map({
      container: this.map,
      style: 'mapbox://styles/mapbox/satellite-v9',
      center: this.centerMap,
      zoom: this.zoomLevel,
    })
  }

  drawOnMap = () => {
    this.mapBox.on('load', () => {
      if (this.polyline) {
        this.mapBox.addLayer({
          id: 'polyline',
          type: 'line',
          source: {
            type: 'geojson',
            data: {
              type: 'Feature',
              geometry: this.polyline
            }
          },
          paint: {
            'line-color': '#ffffff',
            'line-width': 2
          }
        })
      }

      if (this.geojson) {
        for (const feature of this.geojson.features) {
          // create a HTML element for each feature
          const el = document.createElement('div')
          el.className = 'marker'

          const info = {
            title: feature.properties.title,
            suffix: feature.properties.suffix,
            paragraph: feature.properties.text,
            link_text: feature.properties.link_text,
            link_url: feature.properties.link_url,
            image: feature.properties.image,
            current_value: feature.properties.current_value,
            target_value: feature.properties.target_value,
            sidebar_progress_text: feature.properties.sidebar_progress_text
          }

          // make a marker for each feature and add it to the map
          const marker = new mapboxgl.Marker(el)
            .setLngLat(feature.geometry.coordinates)
            .setPopup(
          new mapboxgl.Popup({ offset: 24 }) // add popups
              .setHTML(
                `
                ${info.current_value === info.target_value ? '<div class="infobox__complete">voltooid</div>' : ''}
                <div class="infobox__image">
                  <img src="${feature.properties.image}">
                </div>
                <div class="infobox__content">
                  <h3>${feature.properties.title}</h3>
                  <p>${feature.properties.suffix}</p>
                <div>
                `
              )
          )
          .addTo(this.mapBox)
          .togglePopup()

          marker.getPopup().on('open', () => {
            this.openSidePanel(info)
            this.panelOpen = true
          })

          marker.getPopup().on('close', () => {
            this.panelOpen = false

            setTimeout(() => {
              if (!this.panelOpen) {
                this.closePanel()
              }
            }, 100)
          })

          marker.getElement().addEventListener('click', () => {
            const markerCoordinates = feature.geometry.coordinates

            this.mapBox.flyTo({
              center: markerCoordinates,
              zoom: `${this.zoomLevel + 1}`,
              essential: true
            });
          });
        }
      }
    });
  }

  openSidePanel = (info) => {
    this.openPanel()
    this.setSidePanelContent(info)
  }

  openPanel = () => {
    gsap.to(this.sidePanel, {
      xPercent: 100,
      duration: 0.6,
      ease: 'power3.out'
    })
  }

  closePanel = () => {
    gsap.to(this.sidePanel, {
      xPercent: 0,
      duration: 0.6,
      ease: 'power3.out'
    })
  }

  setSidePanelContent = (info) => {
    this.sidePanelTop.innerHTML = `
      <img src="${info.image}">
      <div class="progress">
        <div class="progress__value" style="width: ${(info.current_value / info.target_value) * 100}%;"></div>
      </div>
      <p>${info.sidebar_progress_text}</p>
    `
    this.sidePanelBottom.innerHTML = `
      <div class="map__sidepanel__bottom__title text-48-alt">
        ${info.title}
      </div>
      <div class="map__sidepanel__bottom__suffix">
        ${info.suffix}
      </div>

      <p class="text-14">
        ${info.paragraph}
      </p>

      ${info.link_text ? `<a href="${info.link_url}" class="button button--sm button--orange">${info.link_text}</a>` : ''}
    `
  }
}
